function ensureBhdCartCheckoutDashFix() {
  if (document.getElementById('bhd-cart-checkout-dash-fix')) return;

  const style = document.createElement('style');
  style.id = 'bhd-cart-checkout-dash-fix';
  style.textContent = `
    .cart-drawer .bhd-checkout-price-button #mini-cart-subtotal::before {
      content: none !important;
      display: none !important;
      width: 0 !important;
      margin: 0 !important;
    }
  `;
  document.head.appendChild(style);
}

ensureBhdCartCheckoutDashFix();

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const separator = root.includes('?') ? '&' : '?';
    const url = `${root}${separator}section_id=cart-manual-recommendations&_=${Date.now()}`;

    fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Manual cart recommendations failed: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector(
          '[data-bhd-manual-cart-recommendations]'
        );

        if (!recommendations || !recommendations.querySelector('li')) return;

        if (this.hasAttribute('data-animate')) {
          recommendations.setAttribute('data-animate', '');
        }

        [...this.attributes].forEach((attribute) => {
          if (attribute.name.startsWith('data-animate-delay-')) {
            recommendations.setAttribute(attribute.name, attribute.value);
          }
        });

        this.replaceWith(recommendations);
      })
      .catch((error) => {
        console.error('Barrio cart recommendations:', error);
      });
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}
